import { jsx, jsxs } from "react/jsx-runtime";
import { Button } from "@blueprintjs/core";
import draggableClassnames from "../constants/draggableClassnames";
import { some, debounce, noop } from "lodash-es";
import prepareRowData from "../utils/prepareRowData";
import React from "react";
import Draggable from "react-draggable";
import RowItem from "../RowItem";
import ReactList from "@teselagen/react-list";
import withEditorInteractions from "../withEditorInteractions";
import estimateRowHeight, { rowHeights } from "./estimateRowHeight";
import {
  defaultContainerWidth,
  defaultMarginWidth,
  defaultCharWidth
} from "../constants/rowviewContants";
import getBpsPerRow from "../withEditorInteractions/getBpsPerRow";
import "./style.css";
import { getClientX, getClientY, getEmptyText } from "../utils/editorUtils";
import isMobile from "is-mobile";
import classnames from "classnames";
import { ZoomRowViewSlider } from "./ZoomRowViewSlider";
import {
  editorDragged,
  editorDragStarted,
  editorDragStopped
} from "../withEditorInteractions/clickAndDragUtils";
import { defaultMemoize } from "reselect";
import { connect } from "react-redux";
import PinchHelper from "../helperComponents/PinchHelper/PinchHelper";
const rowJumpButtonStyle = {
  height: rowHeights.rowJumpButtons.height
};
const bounds = { top: 0, left: 0, right: 0, bottom: 0 };
export class _RowView extends React.Component {
  static defaultProps = {
    sequenceData: { sequence: "" },
    selectionLayer: {},
    // bpToJumpTo:0,
    editorClicked: noop,
    backgroundRightClicked: noop,
    // onScroll: noop,
    width: defaultContainerWidth,
    marginWidth: defaultMarginWidth,
    height: 400,
    charWidth: defaultCharWidth,
    RowItemProps: {}
  };
  zoomHelper = {};
  rowHeightCache = {};
  //this function gives a fairly rough height estimate for the rows so that the ReactList can give a good guess of how much space to leave for scrolling and where to jump to in the sequence
  estimateRowHeight = (index) => {
    if (this.rowHeightCache[index] !== void 0) {
      return this.rowHeightCache[index];
    }
    const { annotationVisibility, annotationLabelVisibility, sequenceData } = this.props;
    const height = estimateRowHeight({
      index,
      cache: {},
      chromatogramData: sequenceData.chromatogramData,
      showJumpButtons: this.showJumpButtons,
      row: this.rowData[index],
      rowCount: this.rowData.length,
      annotationVisibility,
      annotationLabelVisibility
    });
    this.rowHeightCache[index] = height;
    return height;
  };
  getNearestCursorPositionToMouseEvent = (rowData, event, callback) => {
    const { charWidth = defaultCharWidth, sequenceData } = this.props;
    const sequenceLength = sequenceData.noSequence ? sequenceData.size : sequenceData.sequence.length;
    let rowNotFound = true;
    const visibleRowsContainer = this.InfiniteScroller && this.InfiniteScroller.items;
    let nearestCaretPos = 0;
    const selectionStartGrabbed = event.target.classList.contains(
      draggableClassnames.selectionStart
    );
    const selectionEndGrabbed = event.target.classList.contains(
      draggableClassnames.selectionEnd
    );
    some(visibleRowsContainer.childNodes, function(rowDomNode) {
      const boundingRowRect = rowDomNode.getBoundingClientRect();
      if (getClientY(event) > boundingRowRect.top && getClientY(event) < boundingRowRect.top + boundingRowRect.height) {
        rowNotFound = false;
        const row = rowData[Number(rowDomNode.getAttribute("data-row-number"))];
        if (getClientX(event) - boundingRowRect.left < 0) {
          nearestCaretPos = row.start;
        } else {
          const clickXPositionRelativeToRowContainer = getClientX(event) - boundingRowRect.left;
          const numberOfBPsInFromRowStart = Math.floor(
            (clickXPositionRelativeToRowContainer + charWidth / 2) / charWidth
          );
          nearestCaretPos = numberOfBPsInFromRowStart + row.start;
          if (nearestCaretPos > row.end + 1) {
            nearestCaretPos = row.end + 1;
          }
        }
        return true;
      }
    });
    if (rowNotFound) {
      const { top, bottom } = visibleRowsContainer.getBoundingClientRect();
      const numbers = [top, bottom];
      const target = getClientY(event);
      const topOrBottom = numbers.map(function(value, index) {
        return [Math.abs(value - target), index];
      }).sort().map(function(value) {
        return numbers[value[1]];
      })[0];
      let rowDomNode;
      if (topOrBottom === top) {
        rowDomNode = visibleRowsContainer.childNodes[0];
      } else {
        rowDomNode = visibleRowsContainer.childNodes[visibleRowsContainer.childNodes.length - 1];
      }
      if (rowDomNode) {
        const row = rowData[Number(rowDomNode.getAttribute("data-row-number"))];
        nearestCaretPos = row.end;
      } else {
        nearestCaretPos = 0;
      }
    }
    if (this.props.sequenceData.isProtein) {
      nearestCaretPos = Math.round(nearestCaretPos / 3) * 3;
    }
    if (sequenceLength === 0) nearestCaretPos = 0;
    const {
      updateSelectionOrCaret,
      caretPosition,
      selectionLayer,
      caretPositionUpdate,
      selectionLayerUpdate
    } = this.props;
    callback({
      updateSelectionOrCaret,
      caretPosition,
      selectionLayer,
      caretPositionUpdate,
      selectionLayerUpdate,
      sequenceLength,
      doNotWrapOrigin: !(this.props.sequenceData && this.props.sequenceData.circular),
      selectionStartGrabbed,
      selectionEndGrabbed,
      event,
      className: event.target.className,
      shiftHeld: event.shiftKey,
      nearestCaretPos
    });
  };
  UNSAFE_componentWillReceiveProps(props) {
    this.updateScrollPosition(
      this.calledUpdateScrollOnce ? this.props : {},
      props
    );
  }
  updateScrollPosition = (oldProps, newProps) => {
    this.cache = {};
    if (this.dragging === true) {
      return;
    }
    const {
      caretPosition = -1,
      selectionLayer = {},
      matchedSearchLayer = {}
    } = newProps;
    const {
      caretPosition: caretPositionOld = -1,
      selectionLayer: selectionLayerOld = {},
      matchedSearchLayer: matchedSearchLayerOld = {}
    } = oldProps;
    const bpsPerRow = getBpsPerRow(newProps);
    let scrollToBp = -1;
    if (matchedSearchLayer.start > -1 && (matchedSearchLayer.forceUpdate && matchedSearchLayer.forceUpdate !== matchedSearchLayerOld.forceUpdate || matchedSearchLayer.start !== matchedSearchLayerOld.start)) {
      scrollToBp = matchedSearchLayer.start;
    } else if (matchedSearchLayer.end > -1 && (matchedSearchLayer.forceUpdate && matchedSearchLayer.forceUpdate !== matchedSearchLayerOld.forceUpdate || matchedSearchLayer.end !== matchedSearchLayerOld.end)) {
      scrollToBp = matchedSearchLayer.end;
    } else if (caretPosition > -1 && caretPosition !== caretPositionOld) {
      scrollToBp = caretPosition;
    } else if (selectionLayer.start > -1 && (selectionLayer.forceUpdate && selectionLayer.forceUpdate !== selectionLayerOld.forceUpdate && selectionLayer.forceUpdate !== "end" || selectionLayer.start !== selectionLayerOld.start && !selectionLayer.isFromRowView)) {
      scrollToBp = selectionLayer.start;
    } else if (selectionLayer.end > -1 && (selectionLayer.forceUpdate && selectionLayer.forceUpdate !== selectionLayerOld.forceUpdate && selectionLayer.forceUpdate !== "start" || selectionLayer.end !== selectionLayerOld.end && !selectionLayer.isFromRowView)) {
      scrollToBp = selectionLayer.end;
    }
    if (scrollToBp > -1 && this.InfiniteScroller && this.InfiniteScroller.scrollTo) {
      this.calledUpdateScrollOnce = true;
      const rowToScrollTo = Math.floor(scrollToBp / bpsPerRow);
      const [start, end] = this.InfiniteScroller.getVisibleRange();
      if (rowToScrollTo < start || rowToScrollTo > end) {
        setTimeout(() => {
          this.InfiniteScroller && this.InfiniteScroller.scrollTo(rowToScrollTo);
        }, 0);
        clearInterval(this.jumpIntervalId);
        this.jumpIntervalId = setIntervalX(
          () => {
            if (!this.InfiniteScroller) return;
            const [el] = this.InfiniteScroller.items.querySelectorAll(
              `[data-row-number="${rowToScrollTo}"]`
            );
            if (!el) {
              this.InfiniteScroller && this.InfiniteScroller.scrollTo(rowToScrollTo);
              return;
            } else {
              el.scrollIntoView && el.scrollIntoView({
                behavior: "auto",
                block: "nearest",
                inline: "nearest"
              });
              try {
                clearInterval(this.jumpIntervalId);
              } catch {
                console.error();
              }
            }
          },
          100,
          10
          //tnr: we could run this more than 5 times.. doesn't really matter
        );
      }
    }
  };
  cache = {};
  renderItem = (index) => {
    const {
      //currently found in props
      sequenceData,
      // bpToJumpTo,
      editorClicked,
      caretPosition,
      backgroundRightClicked,
      // onScroll,
      width,
      marginWidth,
      height,
      truncateLabelsThatDoNotFit,
      RowItemProps,
      ...rest
    } = this.props;
    let rowTopComp;
    let rowBottomComp;
    const rowData = this.rowData;
    const bpsPerRow = this.bpsPerRow;
    this.showJumpButtons = rowData.length > 15;
    if (this.showJumpButtons) {
      if (index === 0) {
        rowTopComp = /* @__PURE__ */ jsx("div", { style: rowJumpButtonStyle, children: /* @__PURE__ */ jsx(
          Button,
          {
            style: { fontStyle: "italic" },
            intent: "primary",
            icon: "arrow-down",
            minimal: true,
            "data-test": "jumpToEndButton",
            onClick: (e) => {
              e.stopPropagation();
              this.InfiniteScroller && this.InfiniteScroller.scrollTo(rowData.length);
            },
            children: "Jump to end"
          }
        ) });
      } else if (index === rowData.length - 1) {
        rowBottomComp = /* @__PURE__ */ jsx("div", { style: rowJumpButtonStyle, children: /* @__PURE__ */ jsx(
          Button,
          {
            style: { fontStyle: "italic" },
            intent: "primary",
            icon: "arrow-up",
            minimal: true,
            "data-test": "jumpToStartButton",
            onClick: (e) => {
              e.stopPropagation();
              this.InfiniteScroller && this.InfiniteScroller.scrollTo(0);
            },
            children: "Jump to start"
          }
        ) });
      }
    }
    if (rowData[index]) {
      const rowItem = /* @__PURE__ */ jsxs("div", { "data-row-number": index, style: { height: Math.max(40, this.estimateRowHeight(index, {})) }, children: [
        /* @__PURE__ */ jsx("div", { className: "veRowItemSpacer" }),
        /* @__PURE__ */ jsx(
          RowItem,
          {
            ...{
              ...rest,
              rowTopComp,
              truncateLabelsThatDoNotFit,
              rowBottomComp,
              scalePct: this.state?.scalePct,
              setScalePct: (scalePct) => {
                this.setState({ scalePct });
              },
              isRowView: true,
              isProtein: sequenceData.isProtein,
              isRna: sequenceData.isRna,
              chromatogramData: sequenceData.chromatogramData,
              sequenceLength: sequenceData.sequence.length,
              bpsPerRow,
              caretPosition,
              emptyText: getEmptyText({ sequenceData, caretPosition }),
              fullSequence: sequenceData.sequence,
              ...RowItemProps
            },
            row: rowData[index]
          }
        ),
        index === rowData.length - 1 ? /* @__PURE__ */ jsx("div", { className: "veRowItemSpacer" }) : null
      ] }, index);
      return rowItem;
    } else {
      return null;
    }
  };
  onDrag = (event) => {
    if (isMobile({ tablet: true })) {
      if (
        //only allow dragging on mobile if the user is grabbing the cursor
        !some(draggableClassnames, (cn) => {
          if (event.target.classList.contains(cn)) {
            return true;
          }
        })
      ) {
        return;
      }
    }
    this.dragging = true;
    const rowData = this.rowData;
    this.getNearestCursorPositionToMouseEvent(rowData, event, editorDragged);
  };
  onStart = (event) => {
    this.dragging = true;
    const rowData = this.rowData;
    this.getNearestCursorPositionToMouseEvent(
      rowData,
      event,
      editorDragStarted
    );
  };
  onStop = () => {
    this.dragging = false;
    editorDragStopped();
  };
  getRef = (ref) => this.node = ref;
  onContextMenu = (event) => {
    this.getNearestCursorPositionToMouseEvent(
      this.rowData,
      event,
      this.props.backgroundRightClicked
    );
  };
  onClick = (event) => {
    this.getNearestCursorPositionToMouseEvent(
      this.rowData,
      event,
      this.props.editorClicked
    );
  };
  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
    clearInterval(this.centerIntervalId);
    clearInterval(this.jumpIntervalId);
    this.updateVisibleRange?.cancel?.();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.charWidth !== this.props.charWidth || prevProps.bpsPerRow !== this.props.bpsPerRow || prevProps.width !== this.props.width) {
      this.updateVisibleRange();
      setTimeout(this.updateVisibleRange, 150);
      setTimeout(this.updateVisibleRange, 500);
      this.centerSelectionOrCaret();
    }
  }
  centerSelectionOrCaret = () => {
    if (this.dragging === true) {
      return;
    }
    const {
      caretPosition = -1,
      selectionLayer = {},
      matchedSearchLayer = {},
      sequenceData = {}
    } = this.props;
    const seqLen = sequenceData.sequence ? sequenceData.sequence.length : sequenceData.size || 0;
    let targetBp = -1;
    if (selectionLayer.start > -1 && selectionLayer.end > -1) {
      if (selectionLayer.start <= selectionLayer.end) {
        targetBp = Math.floor((selectionLayer.start + selectionLayer.end) / 2);
      } else {
        const selLen = seqLen - selectionLayer.start + selectionLayer.end + 1;
        targetBp = Math.floor(
          (selectionLayer.start + selLen / 2) % (seqLen || 1)
        );
      }
    } else if (caretPosition > -1) {
      targetBp = caretPosition;
    } else if (matchedSearchLayer.start > -1) {
      const end = matchedSearchLayer.end > -1 ? matchedSearchLayer.end : matchedSearchLayer.start;
      targetBp = Math.floor((matchedSearchLayer.start + end) / 2);
    }
    if (targetBp < 0) return;
    const bpsPerRow = this.bpsPerRow || getBpsPerRow(this.props);
    if (!bpsPerRow) return;
    const rowToScrollTo = Math.floor(targetBp / bpsPerRow);
    const maxRow = this.rowData ? this.rowData.length - 1 : seqLen > 0 ? Math.floor((seqLen - 1) / bpsPerRow) : 0;
    const clampedRow = Math.max(0, Math.min(rowToScrollTo, maxRow));
    const scrollToCenter = () => {
      if (!this.InfiniteScroller) return;
      const el = this.InfiniteScroller.items?.querySelector(
        `[data-row-number="${clampedRow}"]`
      ) || this.node?.querySelector(`[data-row-number="${clampedRow}"]`);
      if (!el) {
        this.InfiniteScroller.scrollTo && this.InfiniteScroller.scrollTo(clampedRow);
        return;
      }
      const container = el.closest(".veRowView") || this.node || this.InfiniteScroller.items?.parentElement;
      if (container) {
        const targetEl = el.querySelector(
          ".veRowViewCaret, .veRowViewSelectionLayer, .veSelectionLayer"
        ) || el;
        const containerRect = container.getBoundingClientRect();
        const targetRect = targetEl.getBoundingClientRect();
        const relativeTop = targetRect.top - containerRect.top + container.scrollTop;
        const targetHeight = targetRect.height || targetEl.offsetHeight || 40;
        const containerHeight = containerRect.height || container.clientHeight || 300;
        const targetScrollTop = relativeTop - containerHeight / 2 + targetHeight / 2;
        container.scrollTop = Math.max(0, targetScrollTop);
        this.onScroll();
      }
    };
    if (this.InfiniteScroller && this.InfiniteScroller.scrollTo) {
      const [start, end] = this.InfiniteScroller.getVisibleRange();
      if (clampedRow < start || clampedRow > end) {
        this.InfiniteScroller.scrollTo(clampedRow);
      }
    }
    scrollToCenter();
    clearInterval(this.centerIntervalId);
    this.centerIntervalId = setIntervalX(scrollToCenter, 30, 5);
  };
  getReactListRef = (c) => {
    this.InfiniteScroller = c;
    if (c && !c.__patched) {
      c.__patched = true;
      const originalGetSizeOfItem = c.getSizeOfItem;
      c.getSizeOfItem = function(index) {
        const size = originalGetSizeOfItem.apply(this, arguments);
        if (size === 0 || size === null || size === void 0 || isNaN(size)) {
          return 40;
        }
        return Math.max(40, size);
      };
    }
    !this.calledUpdateScrollOnce && this.updateScrollPosition({}, this.props);
    setTimeout(() => {
      this.onScroll();
    }, 0);
  };
  onScroll = () => {
    if (this.InfiniteScroller) {
      this.updateVisibleRange();
    }
    onScroll();
  };
  updateVisibleRange = debounce(() => {
    if (this.InfiniteScroller && typeof this.InfiniteScroller.getVisibleRange === "function") {
      const range = this.InfiniteScroller.getVisibleRange();
      if (!Array.isArray(range) || range.length < 2) return;
      const [start, end] = range;
      const {
        bpsPerRow,
        updateRowViewVisibleRange,
        sequenceData
      } = this.props;
      if (!sequenceData?.sequence) return;
      const sequenceLength = sequenceData.sequence.length;
      if (updateRowViewVisibleRange) {
        const newRange = {
          start: Math.floor(start * bpsPerRow % sequenceLength),
          end: Math.min(Math.floor((end + 1) * bpsPerRow - 1), sequenceLength - 1)
        };
        updateRowViewVisibleRange(newRange);
      }
    }
  }, 100);
  render() {
    let {
      //currently found in props
      width,
      marginWidth,
      height,
      className,
      bpsPerRow,
      rowData,
      charWidth,
      updateSequenceSpacing,
      sequenceData,
      annotationVisibility,
      annotationLabelVisibility
    } = this.props;
    if (width === "100%") {
      return /* @__PURE__ */ jsx("div", { style: { width, height: height || 300 } });
    }
    if (marginWidth < defaultMarginWidth) {
      marginWidth = defaultMarginWidth;
    }
    const containerWidthMinusMargin = width - marginWidth;
    const cacheKey = `${JSON.stringify(annotationVisibility)}_${JSON.stringify(annotationLabelVisibility)}_${sequenceData?.id || ""}_${sequenceData?.sequence?.length || ""}_${bpsPerRow}_${charWidth}_${width}`;
    if (this.lastCacheKey !== cacheKey || this.lastRowData !== rowData) {
      this.rowHeightCache = {};
      this.lastCacheKey = cacheKey;
      this.lastRowData = rowData;
    }
    this.bpsPerRow = bpsPerRow;
    this.rowData = rowData;
    return /* @__PURE__ */ jsx(
      Draggable,
      {
        enableUserSelectHack: false,
        bounds,
        onDrag: this.onDrag,
        onStart: this.onStart,
        onStop: this.onStop,
        children: /* @__PURE__ */ jsxs(
          PinchHelper,
          {
            className: classnames("veRowViewContainer", className),
            style: {
              position: "relative",
              height: height || 300,
              width: containerWidthMinusMargin + marginWidth,
              display: "flex",
              flexDirection: "column",
              minHeight: 0
            },
            onPinch: ({ delta: [d], event }) => {
              if (!d) return;
              if (event) {
                event.preventDefault && event.preventDefault();
                event.stopPropagation && event.stopPropagation();
              }
              if (this.zoomHelper && this.zoomHelper.triggerChange) {
                this.zoomHelper.triggerChange(({ changeValue, value }) => {
                  const sign = d > 0 ? 1 : -1;
                  const magnitude = Math.max(0.3, Math.abs(d) * 5);
                  const zoomLevelChange = sign * magnitude;
                  const newZoomLevel = Math.max(0, Math.min(10, value + zoomLevelChange));
                  changeValue(newZoomLevel);
                });
              }
            },
            children: [
              /* @__PURE__ */ jsx(
                ZoomRowViewSlider,
                {
                  smallSlider: true,
                  setCharWidth: updateSequenceSpacing,
                  charWidth,
                  minCharWidth: 3,
                  maxCharWidth: 100,
                  zoomHelper: this.zoomHelper,
                  afterOnChange: () => {
                    this.centerSelectionOrCaret();
                    this.onScroll();
                  }
                }
              ),
              /* @__PURE__ */ jsx(
                "div",
                {
                  ref: this.getRef,
                  className: "veRowView",
                  style: {
                    overflowY: "auto",
                    overflowX: "hidden",
                    flexGrow: 1,
                    minHeight: 0,
                    width: "100%",
                    paddingLeft: marginWidth / 2,
                    paddingRight: marginWidth / 2,
                    ...isMobile && { touchAction: "inherit" }
                  },
                  onContextMenu: this.onContextMenu,
                  onScroll: this.onScroll,
                  onClick: this.onClick,
                  children: /* @__PURE__ */ jsx(
                    ReactList,
                    {
                      ref: this.getReactListRef,
                      itemRenderer: this.renderItem,
                      length: rowData.length,
                      itemSizeEstimator: this.estimateRowHeight,
                      type: "variable",
                      clearCache: true
                    },
                    `${sequenceData.id || ""}_${sequenceData._id || ""}_${sequenceData.name || ""}_${sequenceData.sequence?.length || sequenceData.size || ""}_${charWidth}_${bpsPerRow}`
                  )
                }
              )
            ]
          }
        )
      }
    );
  }
}
export const RowView = connect((state, ownProps) => {
  const bpsPerRow = getBpsPerRow(ownProps);
  const rowData = getRowData(ownProps.sequenceData, bpsPerRow);
  return {
    bpsPerRow,
    rowData,
    charWidth: state.VectorEditor[ownProps.editorName].charWidth
  };
})(_RowView);
export default withEditorInteractions(RowView);
function onScroll() {
  if (typeof window !== "undefined") {
    window.__veScrolling = true;
    setTimeout(endScroll);
  }
}
const endScroll = debounce(() => {
  if (typeof window !== "undefined") {
    window.__veScrolling = false;
  }
}, 100);
function setIntervalX(callback, delay, repetitions) {
  let x = 0;
  if (typeof window === "undefined") return null;
  const intervalID = window.setInterval(function() {
    callback();
    if (++x === repetitions) {
      try {
        window.clearInterval(intervalID);
      } catch {
        console.error();
      }
    }
  }, delay);
  return intervalID;
}
const getRowData = defaultMemoize((sequenceData, bpsPerRow) => {
  return prepareRowData(
    {
      ...sequenceData,
      primers: sequenceData.filteredPrimers || sequenceData.primers,
      features: sequenceData.filteredFeatures || sequenceData.features,
      parts: sequenceData.filteredParts || sequenceData.parts
    },
    bpsPerRow
  );
});
